import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import classNames from 'classnames';
import Icon from '../Icon';
import styles from './styles.module.scss';

export default class Captcha extends React.Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  state = {
    random: shortid.generate(),
  };

  refresh = () => this.setState({ random: shortid.generate() });

  handleClick = () => this.refresh();

  render() {
    const { url, className } = this.props;
    const { random } = this.state;

    const captchaClassNames = classNames(styles['captcha'], className);

    return (
      <div
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        className={captchaClassNames}
        tabIndex={-1}
        role="button"
      >
        <img src={`${url}?p=${random}`} onLoad={this.handleLoad} alt="captcha" />
        <Icon className={styles['refresh']} icon="refresh" />
      </div>
    );
  }
}
